import request from '../utils/request';

export function getPayments(params) {
    return request.get('/payments', {params});
}

export function getPayment(paymentId) {
    return request.get(`/payments/${paymentId}`);
}

export function createPayment(data) {
    return request.post(`/payments`, data);
}

export function updatePayment(paymentId, data) {
    return request.put(`/payments/${paymentId}`, data);
}

export function deletePayment(paymentId) {
    return request.delete(`/payments/${paymentId}`);
}
